// Accordion functionality
$('.js-accordion-head').on('click', function(event) {
  event.preventDefault();

  $(this)
    .toggleClass('is-active')
    .next()
    .stop()
    .slideToggle()
    .parent()
    .siblings()
    .find('.is-active')
    .removeClass('is-active')
    .next()
    .slideUp();
});



// WEBPACK FOOTER //
// ./../src/assets/js/accordion.js